var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 657,
    height: 67,
    viewBox: "0 0 657 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.3437 67H60.3032L87.834 17H169.99V0H74.9904V0.255981L48.164 48.9766L22.328 0H0L35.3437 67Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M598.99 67V38.2327L599.188 38H599.205L631.485 0H656.033L618.99 43.6069V67H598.99Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M481.99 0V17H574.035L591.612 31.6092L604.916 15.6022L586.75 0.502808L586.158 0H481.99Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M169.99 26H87.9904V40H169.99V26Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9904 50H169.99V67H87.9904V50Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M198.99 0H178.99V46C178.99 57.598 188.392 67 199.99 67H246.99C247.326 67 247.659 66.9922 247.99 66.9766V51H207.99C203.02 51 198.99 46.9706 198.99 42V0Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.99 0C266.392 0 256.99 9.40198 256.99 21V46C256.99 57.598 266.392 67 277.99 67H324.99C336.588 67 345.99 57.598 345.99 46V21C345.99 9.40198 336.588 0 324.99 0H277.99ZM285.99 16C281.02 16 276.99 20.0294 276.99 25V42C276.99 46.9706 281.02 51 285.99 51H316.99C321.961 51 325.99 46.9706 325.99 42V25C325.99 20.0294 321.961 16 316.99 16H285.99Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M440.99 0H377.99C366.392 0 356.99 9.40198 356.99 21V46C356.99 57.598 366.392 67 377.99 67H440.99V51H385.99C381.02 51 376.99 46.9706 376.99 42V25C376.99 20.0294 381.02 16 385.99 16H440.99V0Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M451.99 0H471.99V67H451.99V0Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M519.99 32H540.99V67H519.99V32Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.7302ee0769a4233ef57cf9e0d2c987ab.svg";
export { ForwardRef as ReactComponent };